import { Flex } from 'antd';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { useTranslation } from 'react-i18next';

import { DashboardTitle } from './components/DashboardTitle';
import { WIDGETS } from './constants';
import { LoadingWrapper, Wrapper } from './styles';

import { AcademiesSelector } from '@/components/Form';
import { LoadingCircleSpinner } from '@/components/Loaders';
import { PagePaddingContainer } from '@/components/PagePaddingContainer';
import { useTagFeatures } from '@/hooks';
import { useMutateProfile, useProfile } from '@/store';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const ResponsiveGridLayout = WidthProvider(Responsive);

const ROW_HEIGHT = 285;

export const DashboardPage = () => {
  const { profile, roleCheck } = useProfile();
  const { switchCurrentAcademy } = useMutateProfile();
  const { t } = useTranslation('DefaultTranslations');

  const { isLoading, canRender } = useTagFeatures();

  if (!profile || isLoading)
    return (
      <PagePaddingContainer>
        <LoadingWrapper>
          <LoadingCircleSpinner />
        </LoadingWrapper>
      </PagePaddingContainer>
    );

  const { role } = profile;
  const widgets = WIDGETS[role];
  const { isAdmin, isManager } = roleCheck;

  const isEditable = isAdmin || isManager;

  const layouts = {
    lg: widgets.map(({ position }, i) => {
      const { x, y, w, h } = position;
      return {
        i: i.toString(),
        x,
        y,
        w,
        h,
        minH: h,
        minW: w
      };
    })
  };

  const handleChangeAcademy = (academyId: string) => {
    switchCurrentAcademy(academyId);
  };

  return (
    <PagePaddingContainer>
      <Wrapper>
        <DashboardTitle />
        <AcademiesSelector
          labelText={t('CHANGE_ACADEMY')}
          value={profile.academy?._id}
          onChange={handleChangeAcademy}
        />

        <ResponsiveGridLayout
          className="layout"
          style={{ margin: '0 auto' }}
          layouts={layouts}
          isDraggable={false}
          isResizable={false}
          rowHeight={ROW_HEIGHT}
          cols={{ lg: 12, md: 12, sm: 1, xs: 1, xxs: 1 }}
          breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
          containerPadding={[0, 0]}
          margin={[16, 16]}>
          {widgets.map(
            ({ Widget, availableForFeature }, i) =>
              canRender(availableForFeature) && (
                <Flex key={i}>
                  <Widget editable={isEditable} />
                </Flex>
              )
          )}
        </ResponsiveGridLayout>
      </Wrapper>
    </PagePaddingContainer>
  );
};
